var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.item.language)?_c('img',{staticClass:"table-language-img",attrs:{"src":this.item.language.file_small_url}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }